//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  Input,
  SimpleGrid,
  Stack,
  Text,
  useTheme,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import React, { useState } from "react";
import { array, object, string } from "yup";
import ExpandingTextArea from "../../../components/form-elements/ExpandingTextArea";
import GenderField, {
  DefaultRadio,
} from "../../../components/form-elements/GenderField";
import Select from "../../../components/form-elements/Select";
import { capFirstLetter, possessiveNoun } from "../../../utils/functions";
import { EnhancedSubjectSelector } from "../components/SubjectSelector";

function isMale(gender) {
  if (gender === "male") return true;
  return false;
}

export const learningNeeds = (isMaleChild) => [
  {
    title: `I feel ${isMaleChild ? "he" : "she"} is falling behind`,
    value: "Falling behind",
    description: `${
      isMaleChild ? "He" : "She"
    }'s struggling with comprehension and needs help with fundamentals`,
  },
  {
    title: "Motivation to improve",
    value: "Needs motivation",
    description: `I want to keep ${
      isMaleChild ? "him" : "her"
    } on track as I feel ${
      isMaleChild ? "he" : "she"
    }'s alright but needs some push`,
  },
  {
    title: "Extend their learning",
    value: "Extend learning",
    description: `${
      isMaleChild ? "He" : "She"
    } needs to be further challenged to learn more and gain mastery`,
  },
];

const learningNeedOptions = (isMaleChild) =>
  learningNeeds(isMaleChild).map((need) => ({
    label: (
      <Box py={1}>
        <Text lineHeight="short" fontWeight="medium">
          {need.title}
        </Text>

        <Text fontSize="sm">{need.description}</Text>
      </Box>
    ),
    value: need.value,
  }));

let initialValue = {
  firstName: "",
  gender: "male",
  classDetail: {
    class: "",
    purpose: "",
    subjects: [],
  },
  curriculum: [],
  learningNeed: "",
  expectation: "",
  special_needs: "None",
};
export function isEmptyChild(v) {
  return (
    v.firstName === "" &&
    v.classDetail?.subjects.length === 0 &&
    v.classDetail?.class === "" &&
    v.classDetail?.purpose === "" &&
    v.curriculum.length === 0 &&
    v.learningNeed === "" &&
    v.expectation === "" &&
    v.special_needs === ""
  );
}
let validationSchema = object().shape({
  firstName: string().trim().required("Enter child's name"),
  gender: string().required("Select child's gender"),
  classDetail: object().shape({
    class: string().required("Select child's class"),
    purpose: string().required("Please select a purpose"),
    subjects: array().of(string()).required("Please select subjects"),
  }),
  curriculum: array().of(string()),
  learningNeed: string().required("Please select learning need"),
  expectation: string().required("Please type an expectation"),
  special_needs: string().required("Please select one"),
});

let placeholders = {
  firstName: {
    label: "Name",
    placeholder: "Child's first name",
  },
  gender: {
    label: "Gender",
  },
  classDetail: {
    class: {
      label: "What class?",
      placeholder: "Select class",
    },
    purpose: {
      label: "Purpose for lessons",
      placeholder: "Select purpose",
    },
    subjects: {
      label: "What subjects?",
      placeholder: "Select subjects",
    },
  },
  curriculum: {
    label: "School curriculum (optional)",
    placeholder: "Select curriculum(s)",
  },
  learningNeed: {
    label: (name) =>
      name
        ? `Which best describes ${possessiveNoun(name)} need?`
        : "Which best describes child's need?",
    placeholder: "Select a learning need",
  },
  expectation: {
    label: "What's your goal for this lesson?",
    placeholder: (isMaleChild) =>
      isMaleChild
        ? "I need my son to read fluently. He is age 7 and can hardly read a sentence on his own. So I need someone to help him improve his reading"
        : "I need my daughter to read fluently. She is age 7 and can hardly read a sentence on her own. So I need someone to help her improve her reading",
  },
  special_needs: {
    label: "Special learning needs?",
  },
};

let commonProps = ({ name }, { touched, errors }) => ({
  ...placeholders[name],
  isInvalid: touched[name] && errors[name],
  errorMessage: errors[name],
});

export const specialNeeds = [
  "ADD/ADHD",
  "Autistic disorder",
  "Cerebral palsy",
  "Down syndrome",
  "Dyscalculia",
  "Dyslexia",
  "Hearing impaired",
  "Speech impaired",
  "Visually impaired",
];

const specialNeedOptions = ["None", ...specialNeeds].map((specialNeed) => ({
  label: specialNeed,
  value: specialNeed,
}));

export const curriculumOptions = [
  "Montessori",
  "EYFS",
  "British",
  "Nigerian",
  "American",
];

const generateClassLabel = (name) => {
  let label = name ? `What class is ${name}?` : "What class?";
  let klass = { label, placeholder: "Select class" };
  return { class: klass };
};

const ChildForm = React.forwardRef((props: any, ref) => {
  let { value = {}, spacing = "24px", onSubmit, path }: any = props;
  const [childName, setChildName] = useState(value.firstName || "");

  const handleSubmit = (values) => {
    onSubmit && onSubmit(values);
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ ...initialValue, ...value }}
      onSubmit={handleSubmit}
      key={props.dataType?.length}
      innerRef={ref}
      ref={ref as any}
    >
      {({ values, handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Stack spacing={spacing} w="100%">
              <Text fontSize="xl" fontWeight="bold">
                1. Class information
              </Text>
              <Flex
                align={["flex-start", "center"]}
                direction={["column", "row"]}
                justify="space-between"
              >
                <Field name="firstName">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={Boolean(commonProps(field, form).isInvalid)}
                      width={["100%", "50%"]}
                    >
                      <FormLabel>{commonProps(field, form).label}</FormLabel>
                      <Input
                        size="lg"
                        fontSize="16px"
                        {...commonProps(field, form)}
                        {...field}
                        onBlur={() => {
                          let value = capFirstLetter(field.value);
                          setChildName(value);
                        }}
                      />
                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Box w={spacing} h={spacing} />

                <Field name="gender">
                  {({ field, form }) => (
                    <FormControl flex={1} pt={[0, -5]}>
                      <FormLabel>{commonProps(field, form).label}</FormLabel>
                      <DefaultRadio
                        isInline
                        py={[0, 2]}
                        size="lg"
                        options="children"
                        {...field}
                        {...commonProps(field, form)}
                        defaultValue={field.value}
                        onChange={(e) =>
                          form.setFieldValue(field.name, e.target.value)
                        }
                      />
                    </FormControl>
                  )}
                </Field>
              </Flex>

              <Field name="classDetail">
                {({ field, form }) => (
                  <EnhancedSubjectSelector
                    path={`${path}/subject-edit`}
                    spacing={spacing}
                    {...commonProps(field, form)}
                    dataType={props.dataType}
                    edit={true}
                    placeholders={{
                      ...placeholders[field.name],
                      ...generateClassLabel(childName),
                    }}
                    {...field}
                    onChange={(values) => {
                      console.log("onChange", field.name, values);
                      form.setFieldValue(field.name, values);
                    }}
                  />
                )}
              </Field>

              <Field name="curriculum">
                {({ field, form }) => {
                  return (
                    <FormControl
                      isInvalid={Boolean(commonProps(field, form).isInvalid)}
                    >
                      <FormLabel>{commonProps(field, form).label}</FormLabel>
                      <CheckboxGroup
                        size="lg"
                        {...commonProps(field, form)}
                        {...field}
                        defaultValue={field.value}
                        onChange={(value) =>
                          form.setFieldValue(field.name, value)
                        }
                      >
                        <SimpleGrid
                          spacing={3}
                          templateColumns={["repeat(2,1fr)", "repeat(4,1fr)"]}
                        >
                          {curriculumOptions.map((option) => (
                            <Checkbox value={option}>
                              <Text ml={1} fontSize="md">
                                {option}
                              </Text>
                            </Checkbox>
                          ))}
                        </SimpleGrid>
                      </CheckboxGroup>

                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  );
                }}
              </Field>

              <Divider py={3} />

              <Text fontSize="xl" py={3} fontWeight="bold">
                2. Learning needs
              </Text>

              <Field name="learningNeed">
                {({ field, form }) => {
                  return (
                    <FormControl
                      isInvalid={Boolean(commonProps(field, form).isInvalid)}
                    >
                      <FormLabel>
                        {commonProps(field, form).label(childName)}
                      </FormLabel>

                      <Select
                        options={learningNeedOptions(isMale(values.gender))}
                        {...commonProps(field, form)}
                        size={values.learningNeed ? "2xl" : "lg"}
                        {...field}
                        onChange={(value) =>
                          form.setFieldValue(field.name, value.value)
                        }
                      />
                      <FormErrorMessage>
                        {commonProps(field, form).errorMessage}
                      </FormErrorMessage>
                    </FormControl>
                  );
                }}
              </Field>

              <Field name="special_needs">
                {({ field, form }) => {
                  return (
                    <FormControl>
                      <FormLabel>{commonProps(field, form).label}</FormLabel>
                      <Select
                        options={specialNeedOptions}
                        {...field}
                        onChange={(value) =>
                          form.setFieldValue(field.name, value.value)
                        }
                        isSearchable={true}
                      />
                    </FormControl>
                  );
                }}
              </Field>

              <Field name="expectation">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={Boolean(commonProps(field, form).isInvalid)}
                  >
                    <FormLabel>{commonProps(field, form).label}</FormLabel>
                    <ExpandingTextArea
                      name={field.name}
                      borderRadius="md"
                      color="blue"
                      rows={4}
                      {...field}
                      {...commonProps(field, form)}
                      placeholder={commonProps(field, form).placeholder(
                        isMale(values.gender)
                      )}
                      onChange={(value) =>
                        form.setFieldValue(field.name, value)
                      }
                    />
                    <FormErrorMessage>
                      {commonProps(field, form).errorMessage}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Stack>
          </form>
        );
      }}
    </Formik>
  );
});

export default ChildForm;

export {
  initialValue,
  validationSchema,
  placeholders,
  specialNeedOptions,
  generateClassLabel,
};

const CustomCheckbox = React.forwardRef((props: any, ref: any) => {
  const { colors } = useTheme();
  const { isChecked, value, ...rest } = props;
  return (
    <Checkbox
      p={[3, 5]}
      width="100%"
      minH="100%"
      ref={ref}
      borderWidth="2xs"
      rounded="lg"
      alignItems="baseline"
      borderColor={isChecked ? "blue.500" : "inherit"}
      boxShadow={isChecked ? `0 0 0 1px ${colors.blue[400]}` : "none"}
      isChecked={isChecked}
      value={value}
      {...rest}
    >
      <Text ml={1}>{value}</Text>
    </Checkbox>
  );
});
